import { Typography } from '@global-engineering-shared/gweb-material-ui';

import BoldText from 'components/BoldText';
import { Dates } from 'context/DateProvider/DateProvider';
import { getFormattedDate } from 'features/FrameDetails/Containers/FrameDetailsEventsChartContainer/utils/getFormattedDate';
import { getFormattedTime } from 'features/FrameDetails/Containers/FrameDetailsEventsChartContainer/utils/getFormattedTime';
import { DEFAULT_TIME_ZONE } from 'utils/defaults';

type FrameDetailsEventsChartLabelProps = {
  dateTimeRange: Dates;
};

const FrameDetailsEventsChartLabel = ({ dateTimeRange }: FrameDetailsEventsChartLabelProps) => {
  return (
    <Typography variant="label">
      Recent Events: <BoldText text={getFormattedTime(dateTimeRange, 'HH:mm', DEFAULT_TIME_ZONE)} />
      , {getFormattedDate(dateTimeRange, 'dd MMM yyyy')}
    </Typography>
  );
};

export default FrameDetailsEventsChartLabel;
